import { Images } from "assets";
import React, { useRef, forwardRef } from "react";
import { TouchableOpacity, Image, StyleSheet, Pressable } from "react-native";
import ChatEmptyView from "./chatEmptyView";
import ChatInputComponent from "./chatInputComponent";
import { fp, hp, spH, spV, wp } from "utils/normalizeV2";
import BottomSheetModal from "components/BottomSheetModal";

const WelcomeModal = forwardRef(
    (
        {
            onClose,
            setInputValue,
            handleCameraPress,
            inputValue,
            handleSendMessage,
            promentCount,
            isMicRecording,
            isTranscript,
            setIsTranscript,
            handleMicPress,
            imageUrl,
            setImageUrl,
            handleDownloadApp,
            setIsTyping,
            optionPress,
        },
        ref
    ) => {
        const _bottomSheetRef = useRef();
        React.useImperativeHandle(ref, () => ({ show, hide }), []);

        const show = () => {
            _bottomSheetRef?.current?.show();
        };

        const hide = () => {
            _bottomSheetRef?.current?.hide();
        };

        return (
            <BottomSheetModal
                MAX_HEIGHT_PERC={1}
                START_PERC={1}
                ref={_bottomSheetRef}
                hideLine
                containerStyle={{
                    backgroundColor: "transparent",
                    zIndex: 100,
                }}
            >
                <Pressable style={styles.modalContainer}>
                    <TouchableOpacity style={styles.closeButton} onPress={onClose}>
                        <Image accessibilityLabel="Close" source={Images.crossIcon} style={styles.closeIcon} />
                    </TouchableOpacity>
                    <ChatEmptyView
                        onOptionPress={(text) => {
                            setInputValue(text);
                            setTimeout(() => {
                                optionPress(text);
                            }, 200);
                        }}
                        onCameraPress={handleCameraPress}
                    />
                    <ChatInputComponent
                        inputValue={inputValue}
                        setInputValue={setInputValue}
                        handleSendMessage={handleSendMessage}
                        promentCount={promentCount}
                        isMicRecording={isMicRecording}
                        isTranscript={isTranscript}
                        setIsTranscript={setIsTranscript}
                        handleMicPress={handleMicPress}
                        imageUrl={imageUrl}
                        setImageUrl={setImageUrl}
                        handleCameraPress={handleCameraPress}
                        handleDownloadApp={handleDownloadApp}
                        setIsTyping={setIsTyping}
                        isFromModal={true}
                    />
                </Pressable>
            </BottomSheetModal>
        );
    }
);

const styles = StyleSheet.create({
    overlay: {
        position: "absolute",
        top: 0,
        left: 0,
        right: 0,
        bottom: 0,
        backgroundColor: "rgba(0, 0, 0, 0.5)",
        justifyContent: "center",
        alignItems: "center",
        zIndex: 1000,
    },
    modalContainer: {
        backgroundColor: "white",
        borderRadius: fp(10),
        padding: spH(30),
        width: "100%",
        maxHeight: hp(550),
        alignItems: "center",
        position: "relative",
    },
    closeButton: {
        position: "absolute",
        top: spV(15),
        right: spH(15),
        zIndex: 1,
    },
    closeIcon: {
        width: wp(15),
        height: hp(15),
    },
});

WelcomeModal.displayName = "WelcomeModal";
export default WelcomeModal;
